import { render, staticRenderFns } from "./MedsurlinkMobile.vue?vue&type=template&id=64f3d2ee&scoped=true"
import script from "./MedsurlinkMobile.vue?vue&type=script&lang=js"
export * from "./MedsurlinkMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f3d2ee",
  null
  
)

export default component.exports